import { Hashids } from './hashids';

export const encode = (value, { salt = null, length = 32 } = {}) => {
  return new Hashids(salt, length).encode(value);
};

export const decode = (value, { salt = null } = {}) => {
  return new Hashids(salt).decode(value)[0];
};
